module.exports = __webpack_public_path__ + "img/ysyl.da088e3f.png";